type PlanetIconSvgProps = {
  className?: string;
  color?: string;
};

export const PlanetIconSvg = ({
  className,
  color = "#A8B4BD",
}: PlanetIconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_7071_898)">
      <path
        d="M1 10C1 12.3869 1.94821 14.6761 3.63604 16.364C5.32387 18.0518 7.61305 19 10 19C12.3869 19 14.6761 18.0518 16.364 16.364C18.0518 14.6761 19 12.3869 19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.3869 1 10 1C7.61305 1 5.32387 1.94821 3.63604 3.63604C1.94821 5.32387 1 7.61305 1 10Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.69141 13.4624H4.11541C4.75794 13.4619 5.37398 13.2063 5.82814 12.7518C6.2823 12.2972 6.53741 11.681 6.53741 11.0384V8.96245C6.53741 8.31956 6.79279 7.70301 7.24738 7.24842C7.70197 6.79383 8.31852 6.53845 8.96141 6.53845C9.27947 6.53845 9.59442 6.4758 9.88827 6.35408C10.1821 6.23236 10.4491 6.05396 10.674 5.82906C10.8989 5.60415 11.0773 5.33716 11.199 5.0433C11.3208 4.74945 11.3834 4.43451 11.3834 4.11645V1.10645M18.9994 9.85845C18.3084 9.50177 17.543 9.31332 16.7654 9.30844H13.7994C13.4754 9.29913 13.1527 9.35492 12.8506 9.4725C12.5485 9.59008 12.2731 9.76706 12.0406 9.99298C11.8081 10.2189 11.6232 10.4892 11.497 10.7878C11.3708 11.0864 11.3058 11.4073 11.3058 11.7314C11.3058 12.0556 11.3708 12.3765 11.497 12.6751C11.6232 12.9737 11.8081 13.244 12.0406 13.4699C12.2731 13.6958 12.5485 13.8728 12.8506 13.9904C13.1527 14.108 13.4754 14.1638 13.7994 14.1544C14.2582 14.1544 14.6983 14.3367 15.0227 14.6612C15.3471 14.9856 15.5294 15.4256 15.5294 15.8844V17.0944"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7071_898">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
